<!-- SOLAPA «COMERCIOS»: todos, con su interruptor. La fila lleva a la ficha del comercio. -->
<div class="space-y-6 pt-2">

  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-stat-grid xl:grid-cols-3"><div class="kb-skeleton h-24 w-full rounded-xl" *ngFor="let s of [1,2,3]"></div></div>
    <div class="kb-skeleton h-64 w-full rounded-xl"></div>
  </div>

  <div class="kb-tira" *ngIf="!cargando && error" role="alert">
    <p class="m-0 text-sm">
      <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
      No se pudieron leer los comercios. <span class="text-muted-foreground">{{ error }}</span>
    </p>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cargar()">
      <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
    </button>
  </div>

  <ng-container *ngIf="!cargando && !error">

    <!-- Las tres cifras. Las dos primeras filtran, como en Comercios. -->
    <div class="kb-stat-grid xl:grid-cols-3">
      <button type="button" class="kb-stat flex w-full flex-col items-start text-left ring-foreground focus-visible:outline-none focus-visible:ring-2"
              [class.ring-2]="filtro === 'prendidos'" [attr.aria-pressed]="filtro === 'prendidos'"
              (click)="filtro = filtro === 'prendidos' ? 'todos' : 'prendidos'">
        <span class="kb-stat-label block">Con el asistente prendido</span>
        <span class="kb-stat-valor block">{{ prendidos }}</span>
        <span class="kb-stat-pie block">de {{ comercios.length }} {{ comercios.length === 1 ? 'comercio' : 'comercios' }}; nace apagado</span>
      </button>
      <div class="kb-stat">
        <span class="kb-stat-label block">Preguntas en 7 días</span>
        <span class="kb-stat-valor block">{{ nf(preguntas7d) }}</span>
        <span class="kb-stat-pie block">las que hicieron los administradores en su portal</span>
      </div>
      <div class="kb-stat">
        <span class="kb-stat-label block">Gasto de hoy</span>
        <span class="kb-stat-valor block">{{ usd(gastoHoy) }}</span>
        <span class="kb-stat-pie block">sumado entre todos los comercios</span>
      </div>
    </div>

    <section class="kb-tarjeta">
      <div class="flex flex-col gap-4 px-6 sm:flex-row sm:flex-wrap sm:items-end">
        <div class="w-full sm:max-w-sm">
          <label class="kb-label !mb-1.5 !text-xs !font-normal !text-muted-foreground" for="ia-buscar-comercio">Buscar</label>
          <div class="kb-buscador">
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <input id="ia-buscar-comercio" type="text" class="kb-input kb-input-icono"
                   placeholder="Código o nombre del comercio" [(ngModel)]="busqueda">
          </div>
        </div>
        <div>
          <span class="mb-1.5 block text-xs text-muted-foreground">Asistente</span>
          <div class="flex flex-wrap gap-1.5" role="group" aria-label="Filtrar por asistente">
            <button type="button" class="kb-chip" [class.kb-chip-activo]="filtro === 'todos'" (click)="filtro = 'todos'">Todos</button>
            <button type="button" class="kb-chip" [class.kb-chip-activo]="filtro === 'prendidos'" (click)="filtro = 'prendidos'">Prendido</button>
            <button type="button" class="kb-chip" [class.kb-chip-activo]="filtro === 'apagados'" (click)="filtro = 'apagados'">Apagado</button>
          </div>
        </div>
        <p class="m-0 text-sm text-muted-foreground sm:ml-auto">
          <span class="tabular-nums">{{ visibles.length }}</span> {{ visibles.length === 1 ? 'comercio' : 'comercios' }}
        </p>
      </div>

      <div class="kb-tarjeta-cuerpo">
        <div class="kb-empty" *ngIf="!comercios.length">
          <span class="kb-empty-icono"><i class="fas fa-store" aria-hidden="true"></i></span>
          <p class="kb-empty-titulo">El servidor no devolvió ningún comercio</p>
        </div>
        <div class="kb-empty" *ngIf="comercios.length && !visibles.length">
          <span class="kb-empty-icono"><i class="fas fa-search" aria-hidden="true"></i></span>
          <p class="kb-empty-titulo">Ningún comercio coincide con el filtro</p>
          <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="busqueda = ''; filtro = 'todos'">Limpiar filtros</button>
        </div>

        <div class="kb-tabla-plana" *ngIf="visibles.length">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th w-16">Asistente</th>
                <th class="kb-th">Comercio</th>
                <th class="kb-th kb-th-num">Tope diario</th>
                <th class="kb-th kb-th-num">Gasto de hoy</th>
                <th class="kb-th kb-th-num">Preguntas hoy</th>
                <th class="kb-th kb-th-num">Preguntas 7 días</th>
                <th class="kb-th">Clave propia</th>
                <th class="kb-th w-10"><span class="sr-only">Abrir</span></th>
              </tr>
            </thead>
            <tbody>
              <!-- 🔴 La fila NO es un botón: adentro hay un interruptor, y dos controles anidados no
                   se pueden usar con teclado ni con lector. El enlace va en el nombre; el clic en el
                   resto de la fila es sólo una comodidad para el ratón. -->
              <tr class="kb-tr kb-tr-clic" *ngFor="let c of visibles; trackBy: porCodigo" (click)="abrir(c)">
                <td class="kb-td">
                  <app-ia-interruptor [encendido]="c.habilitado" [deshabilitado]="!puedeEditar"
                                      [ocupado]="cambiando === c.codigo"
                                      [etiqueta]="(c.habilitado ? 'Apagar el asistente de ' : 'Prender el asistente de ') + (c.nombre || c.codigo)"
                                      (cambiar)="alternar(c, $event)"></app-ia-interruptor>
                </td>
                <td class="kb-td">
                  <a class="kb-td-titulo !text-foreground hover:underline" [routerLink]="['/console/merchants', c.codigo, 'asistente']"
                     (click)="$event.stopPropagation()">{{ c.nombre || c.codigo }}</a>
                  <p class="kb-td-sub font-mono">{{ c.codigo }}</p>
                  <p class="kb-td-sub kb-texto-peligro" *ngIf="errorFila[c.codigo]">{{ errorFila[c.codigo] }}</p>
                </td>
                <td class="kb-td kb-td-num whitespace-nowrap">{{ c.topeDiarioUsd !== null && c.topeDiarioUsd !== undefined ? usd(c.topeDiarioUsd) : 'El general' }}</td>
                <td class="kb-td kb-td-num whitespace-nowrap" [title]="usd(c.gastoHoyUsd)">{{ usdCorto(c.gastoHoyUsd) }}</td>
                <td class="kb-td kb-td-num whitespace-nowrap">{{ nf(c.preguntasHoy) }}</td>
                <td class="kb-td kb-td-num whitespace-nowrap">{{ nf(c.preguntas7d) }}</td>
                <td class="kb-td">
                  <span class="kb-badge kb-badge-contorno" *ngIf="tieneClavePropia(c)"><i class="fas fa-key" aria-hidden="true"></i>Sí</span>
                  <span class="text-sm text-muted-foreground" *ngIf="!tieneClavePropia(c)">No</span>
                </td>
                <td class="kb-td"><i class="fas fa-chevron-right text-xs text-muted-foreground" aria-hidden="true"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-container>
</div>
